<template>
  <ul class="app-list">
    <li v-for="app in apps" :key="app.name">
      <b-link :href="app.link">{{ app.name }}</b-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppList',
  data () {
    return {
      apps: [
        { name: 'Argonium', link: 'https://argonium.com.au' },
        { name: 'The 1768 Risk Assessment Calculator', link: 'https://1768calc.com.au' }
      ]
    }
  }
}
</script>

<style>

</style>
